"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.diamond_exclamation = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var diamond_exclamation = function diamond_exclamation(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'diamond-exclamation-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83515 2.79316C8.89269 1.73561 10.6073 1.73562 11.6649 2.79316L17.7068 8.83515C18.7644 9.89269 18.7644 11.6073 17.7068 12.6649L11.6648 18.7068C10.6073 19.7644 8.89269 19.7644 7.83515 18.7068L1.79316 12.6648C0.735613 11.6073 0.735615 9.89269 1.79316 8.83515L7.83515 2.79316ZM10.6042 3.85382C10.1324 3.38206 9.36757 3.38206 8.89581 3.85382L2.85382 9.89581C2.38206 10.3676 2.38206 11.1324 2.85382 11.6042L8.89581 17.6462C9.36757 18.1179 10.1324 18.1179 10.6042 17.6462L16.6462 11.6042C17.1179 11.1324 17.1179 10.3676 16.6462 9.89581L10.6042 3.85382Z",
    fill: "#4B5563"
  }), react_1["default"].createElement("path", {
    d: "M10.4802 11.9744C10.4554 12.3555 10.1391 12.652 9.7572 12.652C9.37529 12.652 9.05896 12.3555 9.03422 11.9744L8.69932 6.81477C8.66189 6.23822 9.11944 5.75 9.69722 5.75H9.81719C10.395 5.75 10.8525 6.23821 10.8151 6.81477L10.4802 11.9744ZM8.6582 14.682C8.6582 14.374 8.76554 14.1127 8.9802 13.898C9.19487 13.674 9.45154 13.562 9.7502 13.562C10.0582 13.562 10.3195 13.674 10.5342 13.898C10.7582 14.1127 10.8702 14.374 10.8702 14.682C10.8702 14.99 10.7582 15.2513 10.5342 15.466C10.3195 15.6807 10.0582 15.788 9.7502 15.788C9.45154 15.788 9.19487 15.6807 8.9802 15.466C8.76554 15.2513 8.6582 14.99 8.6582 14.682Z",
    fill: "#4B5563"
  }));
};

exports.diamond_exclamation = diamond_exclamation;